
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator, MatSnackBar, MatTableDataSource } from '@angular/material';
import { BehaviorSubject, combineLatest, EMPTY, forkJoin, of, Subject } from 'rxjs';
import { catchError, filter, flatMap, map, mergeAll, mergeMap, tap, toArray } from 'rxjs/operators';
import { AccountService } from '../account.service';
import { Account } from '../models/account';
import { Headset, HeadsetCalibration } from '../models/headset';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';


@Component({
  selector: 'app-headset-list',
  templateUrl: './headset-list.component.html',
  styleUrls: ['./headset-list.component.css']
})
export class HeadsetListComponent implements OnInit, OnChanges {

  @Input() headsets: Headset[];
  @Input() accounts: Account[];

  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Output() unlinked: EventEmitter<number> = new EventEmitter();

  // isLoadingResults = false;

  // calibrations: Map<string, HeadsetCalibration> = new Map();

  displayedColumns = [
    'id',
    'account',
    'model',
    'identifier',
    'actions',
    'calibration_date',
    'calibration_expiry_date',
    'result',
    'certificate',
  ];
  // tableData: Headset[] = [
  //   {id: '1', account_id: '2', identifier: 'asdf', model: 'zxcv', type: 'headset' },
  // ];
  tableData = new MatTableDataSource<HeadsetTableItem>([]);

  headsets$ = new BehaviorSubject<Headset[]>([]);
  accounts$ = new BehaviorSubject<Account[]>([]);

  constructor(
    private accountService: AccountService,
    private snackbar: MatSnackBar,
    public dialog: MatDialog,
    ) { }

  ngOnInit() {
    // headsets
    console.log('oninit', this.headsets, this.accounts);
    this.tableData.paginator = this.paginator;
    // this.tableData.data = this.headsets;
    this.tableData.data = [];

    // combineLatest([this.headsets$, this.accounts$])
    this.headsets$.pipe(
      mergeMap((hss) => {
        console.log(hss);
        return forkJoin(hss.map(hs => {
          const id = parseInt(hs.id, 10);
          return this.accountService.getHeadsetByID(id);
        }));
      }),
      // mergeMap(x => x),
      // tap(x => { console.log(x); }),
      // mergeMap(hs => {
      //   const id = parseInt(hs.id, 10);
      //   return this.accountService.getHeadsetByID(id);
      // }),
      tap(x => { console.log(x); }),
      map(hss => hss.map(hs => {
        const account = this.accounts ? this.accounts.find(x => x.id === tryParse(hs.hardware.account_id)) : null;
        const email = account ? account.email : 'unknown';
        const res: HeadsetTableItem = {
          id: tryParse(hs.hardware.id),
          model: hs.hardware.model,
          identifier: hs.hardware.identifier,
          type: hs.hardware.type,
          account_id: tryParse(hs.hardware.account_id),
          account_email: email,
        };
        if (hs.calibration) {
          res.calibration_date = tryParse(hs.calibration.calibration_date) * 1000;
          res.calibration_expiry_date = tryParse(hs.calibration.calibration_expiry_date) * 1000;
          res.calibration_id = tryParse(hs.calibration.id);
          res.result = hs.calibration.result;
        } else {
          res.result = 'uncalibrated';
        }
        return res;
      })),
      tap(x => { console.log('after map', x); }),
      // {
      //   console.log(hss);
      //   return hss.map(hs => {
      //     const id = parseInt(hs.id, 10);
      //     return this.accountService.getHeadsetByID(id);
      //   });
      // }),
      // map(hss => {

      // })
      // toArray(),
      // tap(x => { console.log(x); }),
      tap(x => {
        this.tableData.data = x;
      })
    ).subscribe(
      x => { console.log('success', x); },
      err => { console.error('error', err); },
      () => { console.log('complete'); },
    );

    this.headsets$.next([]);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // changes
    console.log(changes);
    if (changes.headsets) {
      this.headsets$.next(changes.headsets.currentValue);
    }
    if (changes.accounts) {
      this.accounts$.next(changes.accounts.currentValue);
    }
  }

  unlinkHeadsetAccount(row: HeadsetTableItem) {
    console.log(row);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {heading: 'Confirm you want to unlink the headset from the account'},
      width: '400px',
    });

    const id2 = row.id;

    dialogRef.afterClosed().pipe(
      filter(x => x === 'yes'),
      flatMap(x => this.accountService.unlinkAccountFromHeadset(id2)),
      tap(x => { console.log('unlinked', id2); }),
      catchError(err => {
        console.error('could not unlink headset from account', id2);
        return EMPTY;
      }),
    ).subscribe();
  }

  getCertificate(calibrationID: number) {
    this.accountService.getCertificateURL(calibrationID).pipe(
      tap(url => { console.log('got certificate url', url); }),
      tap(url => { window.open(url, '_blank'); }),
    ).subscribe(
      res => { console.log('success', res); },
      err => { console.error('error', err); },
      () => { console.log('complete'); },
    );
  }
}

interface HeadsetTableItem {
  id: number; // number
  model: string;
  identifier: string;
  type: string;
  account_id: number; // number

  account_email: string;

  calibration_date?: number;
  calibration_expiry_date?: number;
  calibration_id?: number;
  result?: string;
//   calibration?: {
//     id: string; // "321",
//     calibration_date: string; // "1558455260",
//     calibration_expiry_date: string; // "1559455260",
//     hardware_item_id: string; // "472",
//     data: {
//         technician: {
//             name: string;
//         };
//         result: string;
//     };
//     version: string; // "2",
//     result: string; // "valid",
//     playback_source: string; // "aux",
//     software_player: string; // "asdf"
//   };
}

function tryParse(s: string): number {
  try {
    return parseInt(s, 10);
  } catch (err) {
    console.error('could not parse', s, err);
  }
  return -1;
}



// WEBPACK FOOTER //
// ./src/app/headset-list/headset-list.component.ts